import React, { useEffect, useState } from 'react';
import '../../styles/globals.css'
import { Box, Button, Paper, Slider, styled, Typography } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import DashboardMenuHeaderComponent from './header/DashboardMenuHeaderComponent';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';

import { loadStripe } from '@stripe/stripe-js';

import thankyouHeart from '../../images/membership/membership_thankyou_heart.png';


// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_test_qblFNYngBkEdjEZ16jxxoWSM');

const marks = [
    {
        value: 2,
        label: "£2"
    },
    {
        value: 5,
        label: "£5"
    },
    {
        value: 20,
        label: "£20"
    }
];

function DashboardMembershipSuccess() {

    const options = {
        // passing the client secret obtained from the server
        clientSecret: 'pk_test_51NlHKq2MsJ2UXvaBTZGfefwQTqUkXOqltZju9OBTKbeoE9lFA4EqCXOO90Fd0L9bKBM9jhrfnyTfJ9owEWI4ZADs00XMYzFXiK',
    };

    const karmaContext = useKarmaPoolContext();

    useEffect(() => {
        karmaContext.notificationManager.fetchNotifications();
    }, []);

    const [notifications, setNotifications] = useState("");

    useEffect(() => {
        if (karmaContext.local.notifications === undefined ||
            karmaContext.local.notifications[0] === undefined) {
            return;
        }

        setNotifications(karmaContext.local.notifications);

    }, [karmaContext.local.notifications]);


    return RenderDashboardPrimary();
}

function valuetext(value) {
    return `£${value}`;
}

const CustomSlider = styled(Slider)(({ theme }) => ({
    "& .MuiSlider-markLabel": {
        color: "whitesmoke"
    }
}));

function PaymentLinkButton(props) {

    const karmaContext = useKarmaPoolContext();

    function handleClick(event) {
        event.preventDefault();

        karmaContext.paymentManager.getPaymentLink(props.monthlyCost, (data) => {
            console.log("URL : " + data.url + "?client_reference_id=" + karmaContext.local.user.id);
            //window.location.href = data.url + "?client_reference_id=" + karmaContext.local.user.id;

            // Open in new window
            window.open(data.url + "?client_reference_id=" + karmaContext.local.user.id, '_blank');
        });
    }

    return (
        <Button variant="contained" color="info" onClick={handleClick} sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "0.325rem", marginBottom: "0.125rem" }}>
            Subscribe
        </Button>
    );
}

function RenderDashboardPrimary() {

    const karmaContext = useKarmaPoolContext();

    const [monthlyCost, setMonthlyCost] = useState(2);

    function onSliderChange(event, value) {
        setMonthlyCost(value);
    }

    const [stripePromise, setStripePromise] = useState(loadStripe("pk_test_51NlHKq2MsJ2UXvaBTZGfefwQTqUkXOqltZju9OBTKbeoE9lFA4EqCXOO90Fd0L9bKBM9jhrfnyTfJ9owEWI4ZADs00XMYzFXiK"));

    /* useEffect(() => {
       fetch("/config").then(async (r) => {
         const { publishableKey } = await r.json();
         setStripePromise(loadStripe(publishableKey));
       });
     }, []);*/

    return (
        <>
            <Box className={karmaStyles.homepageBox2}>
                <DashboardMenuHeaderComponent
                    nonMember={false} />
            </Box>

            <Box className={karmaStyles.homepageBox3}>
                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", marginBottom: "0.25rem" }}>
                    <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Paper sx={{ marginBottom: "0.5rem" }} />
                            <Box sx={{
                                width: "47.5%", maxWidth: "18rem",
                                minWidth: "18rem", padding: "0.0rem",
                            }}>
                                <Box sx={{ marginTop: "0.0rem" }}>
                                    <strong>You are now a member.</strong>
                                    {/* on click, button should open /karma/dashboard/newsletter */}
                                    <Paper sx={{ marginBottom: "0.6825rem" }} />
                                    <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                        Welcome to the Karma Pool, a collective giving platform that aims to have a big impact.
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Paper sx={{ marginBottom: "1.5rem" }} />
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "0.75rem" }}>
                            <Box sx={{
                                backgroundColor: "rgba(221, 221, 221, 0.05)",
                                borderRadius: "0.25rem",
                                borderColor: "rgba(221, 221, 221, 0.25)",
                                width: "47.5%", maxWidth: "18rem",
                                minWidth: "18rem", paddingTop: "1.0rem",
                                paddingBottom: "1.0rem",
                                border: "1px solid rgba(221, 221, 221, 0.35)",
                            }}>
                                You now get 20 tokens per cycle.

                            </Box>
                        </Box>
                        <Paper sx={{ marginBottom: "1.5rem" }} />
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "0.75rem" }}>
                            <img src={thankyouHeart} alt="logo" width={128} height={128} />
                        </Box>
                        <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                            Thankyou. 
                        </Typography>


                    </Typography>
                </Box>
            </Box>

            <Paper sx={{ marginBottom: "2.45rem" }} />
        </>
    );
}

export default DashboardMembershipSuccess;


